/*
Create a named database that uses the browser's Cache API, with a fallback to IndexedDB.
*/

import { createCacheStorageDatabase } from "./cacheStorageDatabase"
import { createLocalForageDatabase } from "./localForageDatabase"
import { iDatabase } from "./types"
import log from 'modules-core/log'

const logger = log.getLogger('storageDatabase')

export const createStorageDatabase = (name = 'database'): iDatabase => {
	let database: iDatabase

	// Use Cache API, fallback to IndexedDB.
	// See: https://developer.mozilla.org/en-US/docs/Web/API/Window/self
	// See: https://web.dev/cache-api-quick-guide/#where-is-it-available
	if ('caches' in self) {
		logger.info(`Using Cache API for storage database: ${name}`)
		database = createCacheStorageDatabase(name)
		createLocalForageDatabase(name).clear()
	} else {
		logger.info(`Using IndexedDB for cache database: ${name}`)
		database = createLocalForageDatabase(name)
		// If Cache API is not available, we can't open and then clear a Cache API database.
		// createCacheStorageDatabase(name).clear()
	}
	return database
}

export const storageDatabase = createStorageDatabase()
export default storageDatabase
